import React, { Component } from "react";
import AttachBox from "./Attach";
import constant from "./utils/constant";
import ErrorBox from "./Error";
import LinkBox from "./Link";
import RecordBox from "./Record";
import ResponseBox from "./Response";
import {
  time_to_second,
  getUserMedia,
  media_recorder,
  websocket_connection,
} from "./utils/functions";
import ContentHeader from "./ContentHeader";
import Header from "./Header";
import Sidebar from "./Sidebar";
import { MobileMenu } from "../Common/MobileMenu";
import { LanguageSelect, languageOptions } from "./LanguageSelect";
import ResponseNew from "./ResponseNew";
import clsx from "clsx";
import { ToastContainer } from "react-toastify";
import { api } from "../../lib/axios";
import { getAuthToken } from "../../utils/AuthToken";
import { server_transcribe_url, speaker_tasks_diarization } from "./utils/api";


let Stream = null;
let mediaRecorder = null;
let ws = null;

const BORDER_COLORS = {
  small_mic_icon: "#00BA9F",
  small_cloud_icon: "#118AD3",
  small_link_icon: "#FF1654",
};

class Demo extends Component {
  constructor(props) {
    super(props);

    this.analyserRef = React.createRef(null);
    this.dataArrayRef = React.createRef(null);
    this.canvasRef = React.createRef(null);
    this.sourceRef = React.createRef(null);
    this.audioContextRef = React.createRef(null);
    this.audioStreamRef = React.createRef(null);
    // const [isRecording, setIsRecording] = useState(false);

    this.state = {
      // (header showing of icon) states
      activeHeaderIcon: constant.ICON_NAMES.MIC,
      showingRestartIcon: false,

      // language
      selectedLanguage: languageOptions[0].value,

      // (processing) states
      recording: false,
      attaching: false,
      processing: false,
      showingFinalResponse: false,
      percentComplete: 0,
      loadedSize: 0,
      totalSize: 0,

      // for handle recording and send by websocket
      recordedChunksBeforeOpenWs: [], //state for store sound files,that recorded before ws is open (when ws.readyState = 0)
      soundFileIsReading: false,
      recordingResponse: "", // it is text, that exist in segments of response, but in error-response at any chunk, add errorText to it.
      wsConnected: false, // the connection of the websocket with the back server, in the mode of recording and response, is open or not?

      // (successResponse && error) states
      finalResponse: {
        //it is successful response that remove from it error-responses(error chunks that show in recording-response).
        segments: [],
        download_url: "",
        duration: 0,
      },
      error: false,
      changeApi: false,
    };
  }

  _getWsUrl = () => {
    const wsProtocol =
      window.location.protocol === "https:" ? "wss://" : "ws://";

    return this.state.changeApi
      ? `${wsProtocol}${window.location.host}/ws_api/speaker_tasks/diarization/`
      : `${wsProtocol}${window.location.host}/ws_api/transcribe_files/`;
  };

  _getApiUrl = () => {
    return this.state.changeApi
      ? speaker_tasks_diarization
      : server_transcribe_url;
  };





  setSelectedLanguage = (lang) => {
    this.setState({
      selectedLanguage: lang.value,
    });
  };

  _inactivate_microphone_stream = () => {
    Stream && Stream.getTracks().forEach((track) => track.stop());
    ws && ws.close();
  };

  _click_header_icon = (iconName) => {
    if (iconName === constant.ICON_NAMES.RESTART) {
      this.setState({
        showingRestartIcon: false,
        recording: false,
        attaching: false,
        processing: false,
        showingFinalResponse: false,
        finalResponse: {
          segments: [],
          download_url: "",
          duration: 0,
        },
        recordedChunksBeforeOpenWs: [],
        soundFileIsReading: false,
        recordingResponse: "",
        wsConnected: false,
        error: false,
      });
      this._inactivate_microphone_stream();
    } else
      this.setState({
        activeHeaderIcon: iconName,
      });
  };

  // handle response and error
  _set_success_response = (response) => {
    if (this.state.showingRestartIcon) {
      if (
        Array.isArray(response) &&
        response.length > 0 &&
        response[0].duration
      ) {
        const response_obj = response[0];
        response_obj.duration = time_to_second(response_obj.duration);
        this.setState({
          processing: false,
          showingFinalResponse: true,
          finalResponse: response_obj,
        });
      } else {
        this.setState({
          processing: false,
          error: "پاسخی یافت نشد! مجددا تلاش کنید.",
        });
      }
    }
  };

  _set_error_response = (errorObj) => {
    if (this.state.showingRestartIcon) {
      const error_message = "کد خطا: " + errorObj["status"];
      this.setState({ processing: false, error: error_message });
    }
  };

  _set_error_message = (message) => {
    console.log("error: ", message);
    this.setState({ error: message, showingRestartIcon: true });
  };

  // handle attach and sending sound file, and receive data
  _handle_attach_change_input = async (e) => {
    const file_input = e.target;
    const file_name = file_input.files[0].name;
    const upload_form = document.getElementById("upload_form");
    const form_data = new FormData(upload_form);
    form_data.append("language", this.state.selectedLanguage);


    try {
      this.setState({ processing: true, showingRestartIcon: true });

      const token = getAuthToken();

      const apiUrl = this._getApiUrl();
      // const response = await api.post(apiUrl, form_data);
      const response = await api.post(apiUrl, form_data, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`,
        },
        onUploadProgress: (e) => {
          if (e.total) {
            const percentComplete = Math.round((e.loaded * 100) / e.total);
            this.setState({
              attaching: `در حال بارگذاری: %${percentComplete}`,
              percentComplete,
              loadedSize: (e.loaded / (1024 * 1024)).toFixed(2),
              totalSize: (e.total / (1024 * 1024)).toFixed(2),
            });
          }
        },
      });

      this._set_success_response(response.data);
    } catch (error) {
      console.error(error);
      this._set_error_response(error.response || {});
    } finally {
      this.setState({ attaching: false, processing: false });
    }
  };


  // handle sending sound's url,and receive data
  _send_url = async (download_url, post_url) => {
    this.setState({ processing: true, showingRestartIcon: true });
    try {
      const token = getAuthToken();
      const apiUrl = this._getApiUrl();
      const response = await api.post(apiUrl, {
        media_urls: [download_url],
        language: this.state.selectedLanguage,
      });
      this._set_success_response(response.data);
    } catch (error) {
      this._set_error_response(error.response || {});
    } finally {
      this.setState({ processing: false });
    }
  };

  // handle record and sending sound as stream chunks, and receive data
  _send_recorded_sound = (blob, ws) => {
    let reader = new FileReader();
    reader.onload = (e) => {
      this.setState({ soundFileIsReading: false });
      const rawData = e.target.result;
      ws.binaryType = "arraybuffer";
      if (ws.readyState === 1) {
        ws.send(rawData); // send raw binary data
        if (mediaRecorder.state === "inactive") {
          console.log("send request to server for close ws. in loaded data");
          ws.send(constant.API.CLOSE_WS_MESSAGE_TO_SERVER);
        }
      } else if (ws.readyState === 0) {
        //for handle recording before ws is open.
        this.setState((state) => ({
          recordedChunksBeforeOpenWs: [
            ...state.recordedChunksBeforeOpenWs,
            rawData,
          ],
        }));
      }
    };
    reader.readAsArrayBuffer(blob);
    this.setState({ soundFileIsReading: true });
  };

  _onStartWsConnection = () => {
    this.setState({ wsConnected: true });

    // send recorded sound chunks, that recorded before ws is open.
    const { recordedChunksBeforeOpenWs, soundFileIsReading } = this.state;
    const handle_saved_chunks = () => {
      if (ws.readyState === 1) {
        // send recorded sound's chunks, that recorded before ws is open.
        if (recordedChunksBeforeOpenWs.length > 0) {
          recordedChunksBeforeOpenWs.forEach((chunk) => {
            ws.send(chunk);
          });
          if (mediaRecorder.state === "inactive" && !soundFileIsReading) {
            console.log(
              "send request to server for close ws. in open websocket"
            );
            ws.send(constant.API.CLOSE_WS_MESSAGE_TO_SERVER);
          }
          this.setState({ recordedChunksBeforeOpenWs: [] }); //remove all saved rawData
        }
      } else {
        setTimeout(handle_saved_chunks, 100);
      }
    };
    handle_saved_chunks();
  };

  _onMessageWs = (data) => {
    console.log("data is: ", data, typeof data);
    let updated_segments = this.state.finalResponse.segments;
    updated_segments[data.segment_id] = {
      start: data.start,
      end: data.end,
      text: data.text,
    };
    let text_of_segments = this.state.finalResponse.segments
      .map((segment) => segment.text)
      .join(" ");
    this.setState((state) => ({
      recordingResponse: text_of_segments,
      finalResponse: {
        ...state.finalResponse,
        segments: updated_segments,
      },
    }));
  };

  _onEndWsConnection = () => {
    this.setState({ wsConnected: false });
  };

  drawVisualizer = () => {
    const canvas = this.canvasRef.current;
    if (!canvas) return;

    const canvasContext = canvas.getContext("2d");
    const analyser = this.analyserRef.current;
    const dataArray = this.dataArrayRef.current;

    const draw = () => {
      if (!this.state.recording) return;

      analyser.getByteTimeDomainData(dataArray);

      canvasContext.clearRect(0, 0, canvas.width, canvas.height); // Clear the canvas

      canvasContext.lineWidth = 1;
      canvasContext.strokeStyle = "#00B3A1";
      canvasContext.beginPath();

      const sliceWidth = (canvas.width * 1.0) / analyser.frequencyBinCount;
      let x = 0;
      const gapSize = 15; // Gap between segments
      const amplitudeMultiplier = 1.5; // Increase to make waveform taller

      for (let i = 0; i < analyser.frequencyBinCount; i += gapSize) {
        const v = dataArray[i] / 128.0;
        const y = (v * canvas.height * amplitudeMultiplier) / 2;

        canvasContext.moveTo(x, canvas.height / 2); // Start each line from the center
        canvasContext.lineTo(x, y - 5); // Draw line to the calculated height

        x += sliceWidth * gapSize; // Increase X with more spacing to create gaps
      }

      canvasContext.stroke();

      requestAnimationFrame(draw);
    };

    draw();
  };

  _handle_stream = (stream) => {
    // connect websocket to server

    ws = websocket_connection(
      this._getWsUrl(),
      this._onStartWsConnection,
      this._onMessageWs,
      this._onEndWsConnection
    );


    //////////////////////////////////

    // const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
    this.audioStreamRef.current = stream;

    // Create audio context
    const audioContext = new (window.AudioContext ||
      window.webkitAudioContext)();
    this.audioContextRef.current = audioContext;

    // Create analyser node
    const analyser = audioContext.createAnalyser();
    analyser.fftSize = 2048;
    this.analyserRef.current = analyser;

    // Create audio source from microphone stream
    const source = audioContext.createMediaStreamSource(stream);
    this.sourceRef.current = source;

    // Connect source to analyser
    source.connect(analyser);

    // Create a data array to hold audio data
    const bufferLength = analyser.frequencyBinCount;
    const dataArray = new Uint8Array(bufferLength);
    this.dataArrayRef.current = dataArray;

    // Start the visualizer
    this.visualizerInterval = setInterval(() => {
      this.drawVisualizer();
    }, 1);

    //////////////////////////////////

    // handle mediaRecorder
    const audio_type = "audio/webm;codecs=opus";
    mediaRecorder = media_recorder(stream, audio_type);

    let chunks = [];

    mediaRecorder.ondataavailable = (e) => {
      const blob = e.data;
      chunks.push(blob);
      this._send_recorded_sound(blob, ws);
    };
    let start_time_recording;
    let end_time_recording;

    mediaRecorder.onstart = function (e) {
      console.log("recorder started");
      start_time_recording = new Date();
    };

    // MediaRecorder.onstop function should only be executed while stop_button(in header) is clicked in recording mode.
    // But this function is also called unintentionally when you click on the restart_button (in the header).
    // That is not what we want.Therefore, prevent its implementation by setting condition:`if (this.state.recording)`
    mediaRecorder.onstop = (e) => {
      console.log("Recording stopped");
      if (this.state.recording) {
        // if recording state is true
        const blob = new Blob(chunks, { type: audio_type });
        const audioURL = window.URL.createObjectURL(blob);
        end_time_recording = new Date();
        const duration =
          (end_time_recording.getTime() - start_time_recording.getTime()) /
          1000;
        this.setState((state) => ({
          recording: false,
          showingFinalResponse: true,
          finalResponse: {
            ...state.finalResponse,
            media_url: audioURL,
            duration,
          },
        }));
        Stream && Stream.getTracks().forEach((track) => track.stop());
      }
    };

    // start recording audio
    this.setState({ showingRestartIcon: true, recording: true }, () => {
      mediaRecorder.start(1000);
    });
  };

  _start_recording = (e) => {
    // This will prompt for permission if not allowed earlier

    this.setState({ recording: true }, () => {
      getUserMedia({ audio: true })
        .then(this._handle_stream)
        .catch((err) => this._set_error_message(err.message));
    });
  };

  _stop_recording = () => {
    if (this.audioStreamRef.current) {
      this.audioStreamRef.current.getTracks().forEach((track) => track.stop());
    }
    if (this.audioContextRef.current) {
      this.audioContextRef.current.close();
    }
    mediaRecorder.state !== "inactive" && mediaRecorder.stop();
  };

  _handle_change_api = (event) => {
    event.stopPropagation();
    this.setState({ changeApi: !this.state.changeApi });
  };

  render() {
    const {
      activeHeaderIcon,
      showingRestartIcon,
      recording,
      attaching,
      percentComplete,
      loadedSize,
      totalSize,
      processing,
      showingFinalResponse,
      finalResponse,
      recordingResponse,
      wsConnected,
      error,
    } = this.state;
    const iconNames = constant.ICON_NAMES;

    return (
      <div className="demo">
        <Header
          classNames={
            showingFinalResponse || recording || error
              ? "in-response-state"
              : ""
          }
        />
        <MobileMenu />
        <Sidebar />
        <div
          className={clsx(
            "main-section",
            showingFinalResponse || recording || error
              ? "in-response-state"
              : "",
            showingFinalResponse &&
            activeHeaderIcon !== iconNames.MIC &&
            "main-section-answer-show"
          )}
          style={{
            "--border-color": BORDER_COLORS[activeHeaderIcon],
            borderTopRightRadius:
              activeHeaderIcon === "small_mic_icon" ? "0" : "30px",
          }}
        >
          <div className={"content " + (error ? "error-response" : "")}>
            <ContentHeader
              activeIcon={activeHeaderIcon}
              showingRestartIcon={showingRestartIcon}
              onClickFunc={this._click_header_icon}
              error={error}
            />
            {showingFinalResponse &&
              (activeHeaderIcon === iconNames.MIC ? (
                <ResponseBox
                  finalResponse={finalResponse}
                  wsConnected={wsConnected}
                  activeIcon={activeHeaderIcon}
                />
              ) : (
                <ResponseNew
                  onClickFunc={this._click_header_icon}
                  finalResponse={finalResponse}
                  isArchive={false}
                />
              ))}
            {error && <ErrorBox />}
            {!showingFinalResponse && !error && (
              <>
                {activeHeaderIcon === iconNames.MIC && (
                  // <AudioVisualizer/>
                  <RecordBox
                    stopRecording={this._stop_recording}
                    startRecording={this._start_recording}
                    processing={processing}
                    recording={recording}
                    recordingResponse={recordingResponse}
                    wsConnected={wsConnected}
                    canvasRef={this.canvasRef}
                  />
                )}
                {activeHeaderIcon === iconNames.LINK && (
                  <LinkBox
                    sendUrlFunc={this._send_url}
                    processing={processing}
                  />
                )}
                {activeHeaderIcon === iconNames.ATTACH && (
                  // <div
                  // >
                  //   <Processing
                  //     percentComplete={68}
                  //     loadedSize={6.8}
                  //     totalSize={10}
                  //   />
                  // </div>
                  <AttachBox
                    handleAttachChangeInput={this._handle_attach_change_input}
                    processing={processing}
                    attaching={attaching}
                    percentComplete={percentComplete}
                    loadedSize={loadedSize}
                    totalSize={totalSize}
                  />
                )}
              </>
            )}
          </div>
          <div className="language-select-container">
            <div dir="rtl">
              <span>زبان گفتار:</span>
              <LanguageSelect onChange={this.setSelectedLanguage} />
            </div>
            <div
              style={{
                display: activeHeaderIcon !== iconNames.MIC ? "flex" : "none",
              }}
              dir="rtl"
            >
              <span style={{ color: "#2DBC8D", fontSize: "14px" }}>
                تفکیک گوینده ها
              </span>
              <label className="container switch">
                {/* <input type="checkbox" onChange={this._handle_change_api} />
                <span className="checkmark"></span> */}
                <input type="checkbox" onChange={this._handle_change_api} />
                <span className="slider round"></span>
              </label>
            </div>
          </div>
        </div>
        <div dir="rtl">
          <ToastContainer />
        </div>
      </div>
    );
  }
}

export default Demo;
